module.exports = __webpack_public_path__ + "img/logo.34a2daa7.svg";